<div class="d-flex align-items-center">
  <img *ngIf="mainLogoUrl; else logoTextTemplate"
    class="soh-logo"
    [src]="mainLogoUrl" />
  <img *ngIf="customerLogoUrl"
    class="soh-logo ml-3"
    [src]="customerLogoUrl" />
</div>
<ng-template #logoTextTemplate><span class="d-inline-block">SOH</span></ng-template>
